import axios from 'axios';

export const taskService = {
  getTasks: (params) =>
    axios.get('/tasks', { auth: true, params }),

  getTask: (id) =>
    axios.get(`/tasks/${id}`, { auth: true }),

  createTask: (data) =>
    axios.post('/tasks', data, { auth: true }),

  editTask: (id, data) =>
    axios.patch(`/tasks/${id}`, data, { auth: true }),

  deleteTask: (id) =>
    axios.delete(`/tasks/${id}`, { auth: true }),

  updateTaskStatus: (id, status) =>
    axios.patch(`/tasks/${id}/status`, { status }, { auth: true }),
};
